module.exports = __webpack_public_path__ + "img/app-store.bad39c4f.png";